import { ApiClientService, EntityApiService } from '@dfl/react-security';
import { IBusinessAccountRequest } from '../interfaces';

class BusinessAccountRequestService extends EntityApiService<IBusinessAccountRequest> {
  getOne = (id: string, config?: any) =>
    this.handleResponse(ApiClientService.get(this.getPath(`/requests/${id}`), config));

  updateRequest = (id: string, data: Partial<IBusinessAccountRequest>, config?: any) =>
    this.handleResponse(ApiClientService.patch(this.getPath(`/requests/${id}`), data, config));

  accept = (id: string, config?: any) =>
    this.handleResponse(ApiClientService.patch(this.getPath(`/requests/${id}/accept`), {}, config));

  reject = (id: string, rejectionReason: string, config?: any) =>
    this.handleResponse(
      ApiClientService.patch(this.getPath(`/requests/${id}/reject`), { rejectionReason }, config),
    );
}

export default new BusinessAccountRequestService('/ms-auth/api/admin/business-account');
